import { AppPalette } from '../../colors'

export const MuiTextField = {
  styleOverrides: {
    root: {
      // textField-no-bg
      '&.textField-no-bg ': {
        backgroundColor: 'inherit',
        '.MuiOutlinedInput-notchedOutline': {
          backgroundColor: 'inherit',
        },
        '.MuiInputBase-root .MuiInputBase-input ': {
          color: AppPalette.GREY.darker,
          zIndex: '1',
        },
      },
      '&.textField-no-bg .MuiOutlinedInput-root': {
        backgroundColor: 'rgba(0,0,0,0)',
        color: AppPalette.GREY.darker,
      },
    },
  },
}
